export const ADMIN_ADD_BATCH_REQUEST = 'ADMIN_ADD_BATCH_REQUEST';
export const ADMIN_ADD_BATCH_SUCCESS = 'ADMIN_ADD_BATCH_SUCCESS';
export const ADMIN_ADD_BATCH_FAIL = 'ADMIN_ADD_BATCH_FAIL';

export const ADMIN_GET_BATCH_REQUEST = 'ADMIN_GET_BATCH_REQUEST';
export const ADMIN_GET_BATCH_SUCCESS = 'ADMIN_GET_BATCH_SUCCESS';
export const ADMIN_GET_BATCH_FAIL = 'ADMIN_GET_BATCH_FAIL';

export const ADMIN_UPDATE_BATCH_REQUEST = 'ADMIN_UPDATE_BATCH_REQUEST';
export const ADMIN_UPDATE_BATCH_SUCCESS = 'ADMIN_UPDATE_BATCH_SUCCESS';
export const ADMIN_UPDATE_BATCH_FAIL = 'ADMIN_UPDATE_BATCH_FAIL';

export const ADMIN_DELETE_BATCH_REQUEST = 'ADMIN_DELETE_BATCH_REQUEST';
export const ADMIN_DELETE_BATCH_SUCCESS = 'ADMIN_DELETE_BATCH_SUCCESS';
export const ADMIN_DELETE_BATCH_FAIL = 'ADMIN_DELETE_BATCH_FAIL';


export const CLEAR_ERRORS = "CLEAR_ERRORS"; 
